import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconWaterproofProps } from './IconWaterproof.types'
import * as Styled from './styles/IconWaterproof.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWaterproof: FC<IconWaterproofProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWaterproofProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconWaterproofProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M80.74 37.92C65.29 57 44 89.46 44 117.24 44 147 65.92 172 96 172s52-24.12 52-53.87C148 76.62 96 20 96 20S84.44 33.35 80.74 37.92Z'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <path d='M58.74 111.21A40.12 40.12 0 0 0 72 141.47' fill='none' vectorEffect='non-scaling-stroke' />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconWaterproof
